<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h2 style="font-weight:normal">The First Word</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_chap1.vue?a89ff054